import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "meeting__wrapper tw-text-center" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "tw-text-xl tw-font-medium tw-text-[#0c0f4a]" }, " Meeting has not generated from trade side "),
  /*#__PURE__*/_createElementVNode("p", { class: "tw-text-sm tw-font-normal tw-text-[#0c0f4a80] tw-mt-4" }, " Please contact Trade Person ")
], -1)

import GeneralDialog from "@/core/components/modals/GeneralDialog.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MeetingNotCreated',
  emits: ["closeModal"],
  setup(__props, { emit: __emit }) {

const emits = __emit;

const closeModal = () => {
  console.log("onCloseModal");
  emits("closeModal");
};

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(GeneralDialog, { onOnClose: closeModal }, {
    body: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_v_btn, {
        class: "button button-purple-border",
        onClick: closeModal
      }, {
        default: _withCtx(() => [
          _createTextVNode("Cancel")
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})